module.exports = __webpack_public_path__ + "ath_game_web/img/6.1.c6434a6a.png";